<template>
  <div class="setPass">
    <div class="title-text">请设置您的钱包支付密码</div>

    <van-form
        ref="form"
        label-align="center"
        @submit="save">
      <van-field
          v-model="password"
          clearable
          type="number"
          maxLength="6"
          label="钱包密码"
          placeholder="设置钱包密码"
          :rules="[{required: true, message: '必填'}, { validator: validatorPassword, message: '密码必须为6位纯数字' }]"
      >
      </van-field>
      <van-field
          v-model="chekPassword"
          center
          clearable
          type="number"
          maxLength="6"
          label="确认密码"
          placeholder="请输入验证码"
          :rules="[{required: true, message: '必填'},{ validator: validatorChekPassword, message: '两次密码不一致' }]"
      >
      </van-field>
      <div class="btn-con" style="padding: 20px 0 0 0;">
        <van-button round block type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { setPayPassword } from '@/api/wallet/cash'
export default {
  components: {
  },
  data () {
    return {
      password: '',
      chekPassword: ''
    }
  },
  methods:{
    onClickLeft() {
      this.$router.go(-1)
    },
    save(){
      this.$refs['form'].validate().then(()=>{
        setPayPassword({
          chekPassword: this.chekPassword, // 校对密码
          password: this.password, // 密码
          userOpenId: this.session('userOpenId'), // 用户openId
          walletType:0 //钱包类型，0：个人钱包
        }).then(res=>{
          if(res.code===200){
            this.$toast('钱包密码设置成功！')
            this.$emit('setPass', 'ok')
          }else {
            this.$toast(res.message)
          }
        })
      })
    },

    validatorPassword(value, rule){
      if(value){
        let reg = /^\d{6}$/
        if(!reg.test(value)){
          return false
        }else {
          return true
        }
      }else {
        return false
      }
    },
    validatorChekPassword(value){
      if(value){
        return this.password===value
      }else {
        return false
      }
    },
  }
}
</script>

<style lang="less" scoped>
.setPass{
  height: 100%;
  font-size: 16px;
  padding: 20px 15px;
  .title-text{
    font-size: 16px;color: #242424;
    line-height: 40px;text-align: center;
  }

  .van-field{
    margin-bottom: 15px;
  }
}
</style>